export default __webpack_public_path__ + "static/media/donut-etherscan.41c1d888.png";